import { ILegalEntity } from '@cemex-core/types-v2';
import * as fromLegalEntityAction from './../actions/legalEntity.action';

export interface State {
    legalEntity: ILegalEntity | undefined;
}

export const initialState: State = {
    legalEntity: undefined,
};

export function reducer(state = initialState, action: fromLegalEntityAction.Actions): State {
    switch (action.type) {
        case fromLegalEntityAction.ActionTypes.SET_LEGAL_ENTITY: {
            if (!action?.payload?.legalEntityId || action?.payload?.legalEntityId === state?.legalEntity?.legalEntityId) {
                return state;
            }

            return {...state, legalEntity: action.payload};
        }
        default: {
            return state;
        }
    }
}
